import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';

interface NavigationState {
  isFirstNavigationToStudies: boolean;
  isFirstNavigationToQuestionLibrary: boolean;
  isFirstNavigationToApplicants: boolean;
  adminRefreshed: boolean;
}

const initialState: NavigationState = {
  isFirstNavigationToStudies: true,
  isFirstNavigationToQuestionLibrary: true,
  isFirstNavigationToApplicants: true,
  adminRefreshed: false
};

export const NavigationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setFirstNavigationToStudies(value: boolean) {
      patchState(store, { isFirstNavigationToStudies: value });
    },
    setFirstNavigationToQuestionLibrary(value: boolean) {
      patchState(store, { isFirstNavigationToQuestionLibrary: value });
    },
    setFirstNavigationToApplicants(value: boolean) {
      patchState(store, { isFirstNavigationToApplicants: value });
    },
    setAdminRefreshed(value: boolean) {
      patchState(store, { adminRefreshed: value });
    },
    reset() {
      patchState(store, initialState);
    }
  }))
);
